'use strict';

const STORAGE_KEY = 'appBecomeGuideBanner_dismissed';

export default function f($window, $ocLazyLoad, $compile, $rootScope, Storage, userModel) {
  'ngInject';

  const storage = new Storage('local');

  return {
    init() {
      let unbind = $rootScope.$on('$stateChangeStart', () => {
        unbind();
        if (this.shouldDisplay()) {
          this.display();
        }
      });
    },

    display() {
      import('../components/app_become_guide_banner/app_become_guide_banner')
        .then(() => $ocLazyLoad.load({ name: 'components.appBecomeGuideBanner' }))
        .then(() => {
          const element = $compile('<sa-app-become-guide-banner></sa-app-become-guide-banner>')($rootScope.$new());
          $window.document.body.appendChild(element[0]);
        });
    },

    shouldDisplay() {
      const isClosed = storage.get(STORAGE_KEY);

      if (isClosed) {
        return false;
      }

      if (userModel.item.id) {
        return false;
      }

      return true;
    },

    dismiss() {
      storage.set(STORAGE_KEY, true);
    },
  };
}



// WEBPACK FOOTER //
// ./app/src/services/app_become_guide_banner.js